import { authRoles } from 'app/auth';
import CaptchaGenStatEditForm from './editform/CaptchaGenStatEditForm';
import CaptchaGenStatTable from './table/CaptchaGenStatTable';

export default [
	{
		path: '/captchagenstat/edit/:id',
		component: CaptchaGenStatEditForm,
		auth: authRoles.userAccount
	},
	{
		path: '/captchagenstat/:sessionNameParam?',
		component: CaptchaGenStatTable,
		auth: authRoles.userAccount
	}
];
